'use client';

import { Shield, DollarSign, Users, Bus, Smartphone, type LucideIcon } from 'lucide-react';

interface RoleItem {
  title: string;
  description: string;
  iconName: string;
  color: string;
}

interface RoleCardsProps {
  roles: RoleItem[];
}

// Icon mapping
const iconMap: Record<string, LucideIcon> = {
  Shield,
  DollarSign,
  Users,
  Bus,
  Smartphone,
};

export function RoleCards({ roles }: RoleCardsProps) {
  return (
    <div className="px-3 xs:px-4 sm:px-6 md:px-8 py-8 xs:py-10 sm:py-12 md:py-16 lg:py-20 mx-2 sm:mx-4 lg:mx-8">
      <div className="max-w-6xl mx-auto">
        {/* Top Section - Header and Roles Grid */}
        <div className="text-center mb-10 xs:mb-12 sm:mb-16 lg:mb-20">
          {/* Main Title */}
          <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-[#1D2125] mb-4 xs:mb-5 sm:mb-6">
            For every role
          </h2>
        </div>

        {/* Roles Grid - Without Cards */}
        <div className="grid grid-cols-1 xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 xs:gap-7 sm:gap-8 lg:gap-10 mb-10 xs:mb-12 sm:mb-16 lg:mb-20">
          {roles.map((role, index) => {
            const IconComponent = iconMap[role.iconName] || Shield;
            return (
              <div key={index} className="text-left">
                {/* Icon */}
                <div className="mb-3 xs:mb-4 flex justify-start">
                  <div className="w-12 xs:w-13 sm:w-14 h-12 xs:h-13 sm:h-14 rounded-lg xs:rounded-xl bg-[#E2FDCB] flex items-center justify-center">
                    <IconComponent className="h-6 xs:h-6.5 sm:h-7 w-6 xs:w-6.5 sm:w-7 text-[#0D373D]" strokeWidth={2} />
                  </div>
                </div>
                
                {/* Title */}
                <h3 className="text-base xs:text-lg sm:text-xl font-bold text-[#1D2125] mb-2 xs:mb-2.5 sm:mb-3">
                  {role.title}
                </h3>
                
                {/* Description */}
                <p className="text-sm xs:text-sm sm:text-base text-[#4D4F52] leading-relaxed">
                  {role.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
